<template>
  <div class="cr-body-content">
    <flexbox class="content-header">
      <div v-if="!isRelationShow">場景：</div>
      <el-dropdown
        v-if="!isRelationShow"
        trigger="click"
        @command="handleTypeDrop">
        <flexbox>
          <div>{{ sceneInfo ? sceneInfo.name : '請選擇' }}</div>
          <i
            class="el-icon-arrow-down el-icon--right"
            style="color:#777;"/>
        </flexbox>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            v-for="(item, index) in scenesList"
            :key="index"
            :command="item ">{{ item.name }}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-input
        v-model="searchContent"
        class="search-container">
        <el-button
          slot="append"
          icon="el-icon-search"
          @click.native="searchInput"/>
      </el-input>
      <el-button
        class="create-button"
        type="primary"
        @click="isCreate=true">新建</el-button>
    </flexbox>
    <el-table
      v-loading="loading"
      ref="relativeTable"
      :data="list"
      :height="250"
      class="cr-table"
      stripe
      border
      highlight-current-row
      style="width: 100%"
      @select-all="selectAll"
      @selection-change="handleSelectionChange"
      @row-click="handleRowClick">
      <el-table-column
        show-overflow-tooltip
        type="selection"
        align="center"
        width="55"/>
      <el-table-column
        v-for="(item, index) in fieldList"
        :key="index"
        :prop="item.prop"
        :label="item.label"
        :width="150"
        :formatter="fieldFormatter"
        show-overflow-tooltip/>
      <el-table-column/>
    </el-table>
    <div class="table-footer">
      <el-button
        :disabled="currentPage <= 1"
        @click.native="changePage('up')">上一頁</el-button>
      <el-button
        :disabled="currentPage >= totalPage"
        @click.native="changePage('down')">下一頁</el-button>
    </div>
    <c-r-m-create-view
      v-if="isCreate"
      :crm-type="crmType"
      @save-success="getList"
      @hiden-view="isCreate=false"/>
  </div>
</template>
<script type="text/javascript">
import { crmLeadsIndex } from '@/api/customermanagement/clue'
import { crmCustomerIndex } from '@/api/customermanagement/customer'
import { crmContactsIndex } from '@/api/customermanagement/contacts'
import { crmBusinessIndex } from '@/api/customermanagement/business'
import { crmContractIndex } from '@/api/customermanagement/contract'
import { crmProductIndex } from '@/api/customermanagement/product'
import { crmSceneIndex } from '@/api/customermanagement/common'
import { getDateFromTimestamp } from '@/utils'
import moment from 'moment'

export default {
  name: 'CrmRelativeTable', // 相關模組CRMCell
  components: {
    CRMCreateView: () =>
      import('@/views/customermanagement/components/CRMCreateView')
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    /** 多選框 只能選一個 */
    radio: {
      type: Boolean,
      default: true
    },
    /** 沒有值就是全部型別 有值就是當個型別 */
    crmType: {
      type: String,
      default: ''
    },
    /** 已選資訊 */
    selectedData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    /**
     * default 預設  condition 固定條件篩選
     * relative: 相關 新增
     */
    action: {
      type: Object,
      default: () => {
        return {
          type: 'default',
          data: {}
        }
      }
    }
  },
  data() {
    return {
      loading: false, // 載入進度
      searchContent: '', // 輸入內容
      isCreate: false, // 控制新建
      scenesList: [], // 場景資訊
      sceneInfo: null,

      list: [], // 表數據
      fieldList: [], // 表頭數據
      currentPage: 1, // 目前頁數
      totalPage: 1, // 總頁數

      otherItems: [],
      selectedItem: [], // 勾選的數據 點選確定 傳遞給父元件
      /** 格式化規則 */
      formatterRules: {}
    }
  },
  computed: {
    // 展示相關效果 去除場景
    isRelationShow() {
      return this.action.type === 'condition'
    }
  },
  watch: {
    crmType: function(newValue, oldValue) {
      if (newValue != oldValue) {
        this.fieldList = []
        this.getFieldList()
      }
    },
    action: function(val) {
      if (this.action != val) {
        this.sceneInfo = null
        this.list = [] // 表數據
        this.fieldList = [] // 表頭數據
        this.currentPage = 1 // 目前頁數
        this.totalPage = 1 // 總頁數
        if (!this.isRelationShow) {
          this.getSceneList()
        } else {
          this.getFieldList()
        }
      }
    },
    show: {
      handler(val) {
        if (val && this.fieldList.length == 0) {
          // 相關列表展示時不需要場景 直接獲取展示欄位
          if (!this.isRelationShow) {
            this.getSceneList()
          } else {
            this.getFieldList()
          }
        }
      },
      deep: true,
      immediate: true
    },
    // 選擇
    selectedData: function() {
      this.checkItemsWithSelectedData()
    }
  },
  mounted() {},
  methods: {
    /**
     * 重新整理列表
     */
    refreshList() {
      this.currentPage = 1
      this.getList()
    },

    getSceneList() {
      this.loading = true
      crmSceneIndex({
        types: 'crm_' + this.crmType
      })
        .then(res => {
          var defaultScene = res.data.list.filter(function(item, index) {
            return item.is_default === 1
          })
          this.scenesList = res.data.list
          if (defaultScene && defaultScene.length > 0) {
            this.sceneInfo = defaultScene[0]
          }
          if (this.scenesList.length == 0) {
            this.scenesList.push({ scene_id: '', name: '全部' })
            this.sceneInfo = this.scenesList[0]
          }
          this.getFieldList()
        })
        .catch(() => {
          this.loading = false
        })
    },
    /** 獲取欄位 */
    getFieldList() {
      if (this.fieldList.length == 0) {
        var defaultFields = this.getDefaultField()
        for (let index = 0; index < defaultFields.length; index++) {
          const element = defaultFields[index]
          /** 獲取需要格式化的欄位 和格式化的規則 */
          if (element.form_type === 'datetime') {
            this.formatterRules[element.field] = {
              formatter: (time) => {
                if (!time || time == 0) {
                  return ''
                }
                return moment(getDateFromTimestamp(time)).format(
                  'YYYY-MM-DD HH:mm:ss'
                )
              }
            }
          } else if (element.field === 'create_user_id') {
            this.formatterRules[element.field] = {
              type: 'crm',
              formatter: (info) => {
                return info ? info.realname : ''
              }
            }
            /** 聯繫人 客戶 商機 */
          } else if (
            element.field === 'contacts_id' ||
            element.field === 'customer_id' ||
            element.field === 'business_id'
          ) {
            this.formatterRules[element.field] = {
              type: 'crm',
              formatter: (info) => {
                return info ? info.name : ''
              }
            }
          } else if (
            element.field === 'status_id' ||
            element.field === 'type_id' ||
            element.field === 'category_id'
          ) {
            this.formatterRules[element.field] = {
              type: 'crm',
              formatter: (info) => {
                return info || ''
              }
            }
          }

          this.fieldList.push({
            prop: element.field,
            label: element.name
          })
        }
      }
      // 獲取好欄位開始請求數據
      this.getList()
    },
    /** 獲取列表請求 */
    getDefaultField() {
      if (this.crmType === 'leads') {
        return [
          { name: '線索名稱', field: 'name', form_type: 'leads' },
          { name: '下次聯繫時間', field: 'next_time', form_type: 'datetime' },
          { name: '最後跟進時間', field: 'update_time', form_type: 'datetime' },
          { name: '建立時間 ', field: 'create_time', form_type: 'datetime' }
        ]
      } else if (this.crmType === 'customer') {
        return [
          { name: '客戶名稱', field: 'name', form_type: 'customer' },
          { name: '下次聯繫時間', field: 'next_time', form_type: 'datetime' },
          { name: '最後跟進時間', field: 'update_time', form_type: 'datetime' },
          { name: '建立時間 ', field: 'create_time', form_type: 'datetime' }
        ]
      } else if (this.crmType === 'contacts') {
        return [
          { name: '姓名', field: 'name', form_type: 'contacts' },
          { name: '手機', field: 'mobile', form_type: 'mobile' },
          { name: '電話', field: 'telephone', form_type: 'text' },
          { name: '是否關鍵決策人', field: 'decision', form_type: 'text' },
          { name: '職務', field: 'post', form_type: 'text' }
        ]
      } else if (this.crmType === 'business') {
        return [
          { name: '商機名稱', field: 'name', form_type: 'text' },
          { name: '商機金額', field: 'money', form_type: 'text' },
          { name: '客戶名稱', field: 'customer_id', form_type: 'text' },
          { name: '商機狀態組 ', field: 'type_id', form_type: 'text' },
          { name: '狀態 ', field: 'status_id', form_type: 'text' }
        ]
      } else if (this.crmType === 'contract') {
        return [
          { name: '合同編號', field: 'num', form_type: 'text' },
          { name: '合同名稱', field: 'name', form_type: 'text' },
          { name: '客戶名稱', field: 'customer_id', form_type: 'text' },
          { name: '合同金額', field: 'money', form_type: 'text' },
          { name: '開始日期', field: 'start_time', form_type: 'text' },
          { name: '結束日期', field: 'end_time', form_type: 'text' }
        ]
      } else if (this.crmType === 'product') {
        return [
          { name: '產品名稱', field: 'name', form_type: 'text' },
          { name: '單位', field: 'unit', form_type: 'text' },
          { name: '價格', field: 'price', form_type: 'text' },
          { name: '產品類別', field: 'category_id', form_type: 'text' },
          { name: '狀態 ', field: 'status', form_type: 'text' }
        ]
      }
    },
    /** 格式化欄位 */
    fieldFormatter(row, column) {
      // 如果需要格式化
      var aRules = this.formatterRules[column.property]
      if (aRules) {
        if (aRules.type === 'crm') {
          if (column.property) {
            return aRules.formatter(row[column.property + '_info'])
          } else {
            return ''
          }
        } else {
          return aRules.formatter(row[column.property])
        }
      }
      return row[column.property]
    },
    /** 獲取列表數據 */
    getList() {
      this.loading = true
      var crmIndexRequest = this.getIndexRequest()

      var params = {
        page: this.currentPage,
        limit: 10,
        search: this.searchContent
      }
      // 注入場景
      if (this.sceneInfo) {
        params.scene_id = this.sceneInfo.scene_id
      }
      // 注入關聯ID
      if (this.isRelationShow) {
        // 客戶下相關展示
        if (this.action.data.form_type === 'customer') {
          // 是什麼型別下的數據 傳入什麼型別的ID
          params.customer_id = this.action.data.customer_id
          if (this.action.data.params) {
            for (const field in this.action.data.params) {
              params[field] = this.action.data.params[field]
            }
          }
        }
      }

      crmIndexRequest(params)
        .then(res => {
          this.list = res.data.list
          /**
           *  如果已選擇的有數據
           */
          if (this.selectedData[this.crmType]) {
            this.checkItemsWithSelectedData()
          } else {
            this.list = res.data.list
          }

          this.totalPage = Math.ceil(res.data.dataCount / 10)
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    // 標記選擇數據
    checkItemsWithSelectedData() {
      const selectedArray = this.selectedData[this.crmType].map(item => {
        item.has = false
        return item
      })

      const selectedRows = []
      this.otherItems = []

      this.list.forEach((item, index) => {
        selectedArray.forEach((selectedItem, selectedIndex) => {
          if (
            item[this.crmType + '_id'] == selectedItem[this.crmType + '_id']
          ) {
            selectedItem.has = true
            selectedRows.push(item)
          }
        })
      })

      selectedArray.forEach((selectedItem, selectedIndex) => {
        if (!selectedItem.has) {
          this.otherItems.push(selectedItem)
        }
      })

      this.$nextTick(() => {
        this.$refs.relativeTable.clearSelection()
        selectedRows.forEach(row => {
          this.$refs.relativeTable.toggleRowSelection(row, true)
        })
      })
    },
    /** 獲取列表請求 */
    getIndexRequest() {
      if (this.crmType === 'leads') {
        return crmLeadsIndex
      } else if (this.crmType === 'customer') {
        return crmCustomerIndex
      } else if (this.crmType === 'contacts') {
        return crmContactsIndex
      } else if (this.crmType === 'business') {
        return crmBusinessIndex
      } else if (this.crmType === 'contract') {
        return crmContractIndex
      } else if (this.crmType === 'product') {
        return crmProductIndex
      }
    },
    // 場景選擇
    handleTypeDrop(command) {
      this.sceneInfo = command
      this.getList()
    },
    /** 列表操作 */
    // 當某一行被點選時會觸發該事件
    handleRowClick(row, column, event) {},
    // 當選擇項發生變化時會觸發該事件
    handleSelectionChange(val) {
      if (this.radio) {
        // this.$refs.relativeTable.clearSelection();
        val.forEach((row, index) => {
          if (index === val.length - 1) return
          this.$refs.relativeTable.toggleRowSelection(row, false)
        })
        if (val.length === 0) {
          this.selectedItem = []
        } else {
          this.selectedItem = val.length === 1 ? val : [val[val.length - 1]]
        }
      } else {
        this.selectedItem = this.otherItems.concat(val)
      }
      this.$emit('changeCheckout', {
        data: this.selectedItem,
        type: this.crmType
      })
    },
    clearAll() {
      this.$refs.relativeTable.clearSelection()
    },
    // 	當用戶手動勾選全選 Checkbox 時觸發的事件
    selectAll() {},
    // 進行搜索操作
    searchInput() {
      this.currentPage = 1
      this.totalPage = 1
      this.getList()
    },
    changePage(type) {
      if (type == 'up') {
        this.currentPage = this.currentPage - 1
      } else if (type == 'down') {
        this.currentPage = this.currentPage + 1
      }
      if (this.currentPage <= this.totalPage && this.currentPage >= 1) {
        this.getList()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.cr-body-content {
  position: relative;
  background-color: white;
  border-bottom: 1px solid $xr-border-line-color;
}

.content-header {
  position: relative;
  padding: 10px 20px;
  .search-container {
    margin: 0 20px;
    width: 200px;
  }
  .create-button {
    position: absolute;
    right: 10px;
    top: 15px;
  }
}

//表尾 上一頁按鈕
.table-footer {
  padding: 8px 20px;
}

.el-table::v-deepthead th {
  font-weight: 400;
  font-size: 12px;
}

.el-table::v-deeptbody tr td {
  font-size: 12px;
}

.el-table::v-deepthead .el-checkbox {
  display: none;
}
</style>
